"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoData = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _ui = require("../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "currentColor"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NoData = function NoData(_ref) {
  var replenishPath = _ref.replenishPath,
    buttons = _ref.buttons,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransactionsTable', 'libCommon']),
    t = _useTranslation.t;
  var history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement(_ui.NoData, {
    title: title !== null && title !== void 0 ? title : t('noTransactions.title'),
    subtitle: subtitle !== null && subtitle !== void 0 ? subtitle : t('noTransactions.text'),
    button: buttons !== null && buttons !== void 0 ? buttons : /*#__PURE__*/_react.default.createElement(_ui.Button, {
      color: "secondary",
      iconPosition: "left",
      icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
        as: arrowRotate,
        size: 10
      }),
      onClick: function onClick() {
        return history.push(replenishPath);
      }
    }, t('libCommon:deposit'))
  });
};
exports.NoData = NoData;